export default __webpack_public_path__ + "static/media/banner_video.b74e3bf5.mp4";